import React, { useState } from 'react';
import {
  Card, CardTitle, CardContent, CardHeader, CardGradientText,
} from '@/components/overseaHome/ui/Card';
import type { OverseaFeatureItem } from '@/apiSdk/api.type';
import useIsClient from '@/hooks/useIsClient';
import { useOfficialHomeContext } from '@/components/overseaHome/OfficialHomeContext';
import { OFFICIAL_HOME_LOCALIZED_CONTENT } from '@/components/overseaHome/localizedContent';
import Overviews from './Overviews';
import SwitchCategory from './SwitchCategory';
import styles from './index.module.scss';

/** 按官网请求语言展示能力概览文案与产品分类。 */
export default function CapabilitiesOverview({ productMenus }: { productMenus: OverseaFeatureItem[]; }) {
  const [activeCategory, setActiveCategory] = useState<number>(productMenus?.[0]?.category_id ?? 0);
  const isClient = useIsClient();
  const officialHome = useOfficialHomeContext();
  // 官网 SSR 与客户端共用请求语言，独立渲染时以英文兜底。
  const content = OFFICIAL_HOME_LOCALIZED_CONTENT[officialHome?.languageCode ?? 'en'].capabilitiesOverview;

  const handleCategoryClick = (id: number) => {
    setActiveCategory(id);
  };

  const getDisplayStyle = (categoryId: number) => {
    // 服务端渲染时显示全部
    if (!isClient) return 'block';
    // 客户端根据 activeCategory 控制显隐
    return activeCategory === categoryId ? 'block' : 'none';
  };

  return (
    <div>
      <Card style={{ paddingRight: '0px', paddingLeft: '0px' }}>
        <CardHeader style={{ paddingRight: '16px', paddingLeft: '16px' }}>
          <CardGradientText className={styles.cardGradientText}>
            {content.title}
          </CardGradientText>
          <CardTitle>{content.description}</CardTitle>
        </CardHeader>
        <CardContent className={styles.overviewsContainer} style={{ paddingLeft: '16px' }}>
          <SwitchCategory productMenus={productMenus} activeCategory={activeCategory} handleCategoryClick={handleCategoryClick} />
          {productMenus?.map((category) => (
            <div
              key={category.category_id}
              style={{ display: getDisplayStyle(category.category_id) }}
            >
              <Overviews categorys={category.list || []} />
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
